export const styles = {
    container: {
        display: "flex",
        flexDirection: "column" as const,
        gap: { base: "4.8", xl: "2.4" },
    },
    header: {
        px: { base: "16px", xl: "32px" },
        alignItems: "center",
        mb: 0,
    },
    title: {
        fontWeight: "bold",
    },
    navContainer: {
        flexDirection: "column" as const,
        alignItems: "flex-end" as const,
        gap: 2,
        flexShrink: 0,
        w: "64px",
    },
    navRow: {
        alignItems: "center" as const,
        w: "full",
    },
    navButtons: {
        display: "flex",
        gap: { base: 0, xl: "4px" },
        w: "full",
    },
    navButton: {
        w: { base: "32px", xl: "30px" },
        h: { base: "32px", xl: "30px" },
        minW: { base: "32px", xl: "30px" },
        borderRadius: 0,
        border: "1px solid",
        borderColor: "black",
        bg: "white",
        _focus: { outline: "none" },
        _focusVisible: { outline: "1px solid black", outlineOffset: "2px" },
        _disabled: {
            opacity: 0.35,
            cursor: "not-allowed",
            pointerEvents: "none",
        },
    },
    navButtonPrev: {
        mr: { base: "-1px", xl: 0 },
    },
    indicatorContainer: {
        display: { base: "none", xl: "flex" },
        alignItems: "center",
        gap: "5px",
        w: "full",
    },
    indicatorActive: {
        flex: 1,
        minW: 0,
        h: "2px",
        borderRadius: "2px",
        bg: "black",
        flexShrink: 1,
    },
    indicatorDot: {
        w: "4px",
        h: "4px",
        borderRadius: "full",
        bg: "gray.100",
        flexShrink: 0,
    },
    slider: (gap: number) => ({
        display: "flex",
        flexDirection: "row" as const,
        flexWrap: "nowrap" as const,
        gap: `${gap}px`,
        overflowX: "auto" as const,
        overflowY: "hidden" as const,
        alignItems: "stretch" as const,
        scrollSnapType: "x mandatory",
        paddingLeft: { base: "16px", xl: "32px" },
        paddingRight: { base: "16px", xl: "32px" },
        paddingBottom: [3, 0],
        scrollPaddingLeft: { base: "16px", xl: "32px" },
        scrollPaddingRight: { base: "16px", xl: "32px" },
    }),
    sliderPseudo: {
        scrollbarWidth: "none",
        msOverflowStyle: "none",
        WebkitOverflowScrolling: "touch",
        "::-webkit-scrollbar": { display: "none" },
    },
    tile: {
        scrollSnapAlign: "start" as const,
        flexShrink: 0,
        flexGrow: 0,
    },
};
